const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "Quiénes somos",
    "termsOfService": "Términos de uso",
    "privacyPolicy": "Política de privacidad",
    "guaranteeOfRights": "Derechos del propietario de los datos",
    "customerSupport": "ATENCIÓN AL CLIENTE",
    "cookiePolicy": "Política de cookies",
    "declarationOfSafety": "Seguridad・Declaración de seguridad",
    "youthProtectionPolicy": "Política de Protección de la Juventud",
    "communityPolicy": "Política de la comunidad",
    "probability": "probability",
    "operationPolicy": "Política de funcionamiento",
    "doNotSell": "No vender mi información personal",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "회원정책",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "Consentimiento de servicio de NC",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "Información adicional en cumplimiento con las leyes de juego",
    "brandInformation": "Información de la compañía nombrada",
    "copyright": "Derechos de autor",
    "channelingInfo": "NC es un agente que media en el comercio electrónico de juegos de canalización dentro de plaync. No forma parte del departamento de Ventas.<br>Todas las obligaciones y responsabilidades asociadas con los juegos de canalización provistos recaen en la parte de comercio electrónico individual, y nosotros no somos responsables por las cuestiones relacionadas con ellos."
  },
  "infoCS": {
    "businessInformation": "Ver información comercial",
    "infoAddress": "Nombre de la empresa: NC Corporation. Co-CEO: Kim Taek-Jin, Co-CEO: Park Byung-Moo. Número de registro comercial: 220-81-43000. E-commerce Registration: 2026-Seongnam Bundang A-0316.",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Dirección: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, República de Corea. Atención al CLIENTE: +82 1600-0020. Fax: +82 02-2186-3550.",
    "pc": "Dirección: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, República de Corea. Atención al CLIENTE: +82 1600-0020. Fax: +82 02-2186-3550.",
    "ncfamilyzone": "Dirección: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, República de Corea. Atención al CLIENTE: +82 1600-0020. Fax: +82 02-2186-3550.",
    "other": "Dirección: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, República de Corea. Atención al CLIENTE: +82 1600-0020. Fax: +82 02-2186-3550.",
    "none": "",
    "infoEmail": "Correo electrónico",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "Título",
    "jpGenre": "Género",
    "jpPrice": "Precio",
    "jpPriceValue": "Gratis (contiene compras dentro de la aplicación)",
    "jpOs": "Sistema operativo compatible",
    "jpPlatform": "Plataforma",
    "jpDevelopedBy": "Desarrollador/editor",
    "jpReleaseDay": "Fecha de lanzamiento",
    "jpReleaseDayValue_LW": "4 de noviembre de 2021"
  },
  "country": {
    "KR": "Corea, República de",
    "TW": "Taiwán",
    "RU": "Rusia",
    "MY": "Malasia",
    "SA": "Arabia Saudita",
    "SG": "Singapur",
    "AE": "Emiratos Árabes Unidos",
    "ID": "Indonesia",
    "JP": "Japón",
    "QA": "Catar",
    "TH": "Tailandia",
    "PH": "Filipinas",
    "HK": "Hong Kong",
    "UA": "Ucrania",
    "BY": "Bielorrusia",
    "LT": "Lituania",
    "PL": "Polonia",
    "GR": "Grecia",
    "IL": "Israel",
    "KW": "Kuwait",
    "AT": "Austria",
    "US": "Estados Unidos de América",
    "CA": "Canadá",
    "DE": "Alemania",
    "GB": "Reino Unido",
    "FR": "Francia",
    "BR": "Brasil",
    "IT": "Italia",
    "ES": "España",
    "CL": "Chile",
    "NO": "Noruega",
    "SE": "Suecia",
    "IE": "Irlanda",
    "PT": "Portugal",
    "FI": "Finlandia",
    "DK": "Dinamarca",
    "CH": "Suiza",
    "AR": "Argentina",
    "PE": "Perú",
    "MX": "México",
    "KZ": "Kazajstán",
    "UZ": "Uzbekistán",
    "AZ": "Azerbaiyán",
    "GE": "Georgia",
    "MD": "Moldavia",
    "AM": "Armenia",
    "MO": "Macao",
    "IN": "India",
    "PK": "Paquistán",
    "NL": "Países Bajos",
    "RO": "Rumania",
    "AU": "Australia",
    "TR": "Turquía",
    "EC": "Ecuador",
    "CO": "Colombia",
    "ZA": "Sudáfrica",
    "EG": "Egipto",
    "NC": "Global"
  }
};

export default l10n;
